import { TLead, leadsServiceHandlers } from '../../..'
import { useNotification } from '@/core'
import { useMutation } from '@tanstack/vue-query'
import { AxiosError } from 'axios'

export const useLeadQuery = () => {
  const { errorHttpNotification } = useNotification()

  const addRecord = useMutation<TLead, AxiosError, TLead>(
    (payload: TLead) => leadsServiceHandlers.addRecord(payload),
    {
      onError: (error) => errorHttpNotification(error),
    },
  )

  return {
    addRecord,
  }
}
